import type { PageBlock } from '@/types/block';
import type { Page } from '@/types/page';
import type { PageSection } from '@/types/page-section';

export const PageEditorActionType = {
  PAGE_UPDATE: 'PAGE_UPDATE',
  PAGE_SECTION_ADD: 'PAGE_SECTION_ADD',
  PAGE_SECTION_UPDATE: 'PAGE_SECTION_UPDATE',
  PAGE_SECTION_DELETE: 'PAGE_SECTION_DELETE',
  PAGE_SECTION_REORDER: 'PAGE_SECTION_REORDER',
  PAGE_BLOCK_ADD: 'PAGE_BLOCK_ADD',
  PAGE_BLOCK_UPDATE: 'PAGE_BLOCK_UPDATE',
  PAGE_BLOCK_DELETE: 'PAGE_BLOCK_DELETE',
} as const;

export type PageEditorActionTypeName =
  (typeof PageEditorActionType)[keyof typeof PageEditorActionType];

export interface PageEditorUpdatePageAction {
  type: typeof PageEditorActionType.PAGE_UPDATE;
  payload: Partial<Page>;
}

export interface PageEditorAddSectionAction {
  type: typeof PageEditorActionType.PAGE_SECTION_ADD;
  payload: {
    sectionId: string;
    section: PageSection;
    insertRowPosition?: number;
  };
}

export interface PageEditorUpdateSectionAction {
  type: typeof PageEditorActionType.PAGE_SECTION_UPDATE;
  payload: {
    sectionId: string;
    updates: Partial<PageSection>;
  };
}

export interface PageEditorDeleteSectionAction {
  type: typeof PageEditorActionType.PAGE_SECTION_DELETE;
  payload: {
    sectionId: string;
  };
}

export interface PageEditorReorderSectionsAction {
  type: typeof PageEditorActionType.PAGE_SECTION_REORDER;
  payload: {
    sectionIds: string[];
  };
}

export interface PageEditorAddBlockAction {
  type: typeof PageEditorActionType.PAGE_BLOCK_ADD;
  payload: {
    sectionId: string;
    blockId: string;
    block: PageBlock;
  };
}

export interface PageEditorUpdateBlockAction {
  type: typeof PageEditorActionType.PAGE_BLOCK_UPDATE;
  payload: {
    sectionId: string;
    blockId: string;
    updates: Partial<PageBlock>;
  };
}

export interface PageEditorDeleteBlockAction {
  type: typeof PageEditorActionType.PAGE_BLOCK_DELETE;
  payload: {
    sectionId: string;
    blockId: string;
  };
}

export type PageEditorAction =
  | PageEditorUpdatePageAction
  | PageEditorAddSectionAction
  | PageEditorUpdateSectionAction
  | PageEditorDeleteSectionAction
  | PageEditorReorderSectionsAction
  | PageEditorAddBlockAction
  | PageEditorUpdateBlockAction
  | PageEditorDeleteBlockAction;
